import './finanziamenti-garanzie-page.scss';

/**
 * version    1.0
 * class      <type> (FinanziamentiGaranziePage)
 * classdesc  Component that manage the Finanziamenti e Garanzie Page
 */
export class FinanziamentiGaranziePage {}
